'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.default = infoBlock;
exports.updateBlock = updateBlock;
exports.updateField = updateField;
exports.addBlock = addBlock;
exports.sort = sort;
exports.copyBlock = copyBlock;
exports.deleteBlock = deleteBlock;
exports.clean = clean;

var _reactSortableHoc = require('react-sortable-hoc');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATEBLOCK = 'infoBlock/UPDATEBLOCK';UPDATEFIELD;
var ADDBLOCK = 'infoBlock/ADDBLOCK';
var UPDATEFIELD = 'infoBlock/UPDATEFIELD';
var SORT = 'infoBlock/SORT';
var DELETE = 'infoBlock/DELETE';
var COPY = 'infoBlock/COPY';
var CLEAN = 'infoBlock/CLEAN';

var initialState = {};

function infoBlock() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case UPDATEBLOCK:
      state[action.index].company = action.company;
      state[action.index].designation = action.designation;
      state[action.index].location = action.location;
      state[action.index].short_title = action.short_title;
      state[action.index].title = action.title;
      state[action.index].date_from = action.date_from;
      state[action.index].date_to = action.date_to;
      state[action.index].description = action.description;
      state[action.index].chart_data = action.chart_data;
      state[action.index].chart_type = action.chart_type;
      return {
        state: state
      };
    case ADDBLOCK:
      var new_state = state;
      // console.log(state);
      var object = {};
      object['company'] = action.company;
      object['heading'] = action.heading;
      object['designation'] = action.designation;
      object['location'] = action.location;
      object['short_title'] = action.short_title;
      object['title'] = action.title;
      object['date_from'] = action.date_from;
      object['date_to'] = action.date_to;
      object['description'] = action.description;
      object['chart_data'] = action.chart_data;
      object['chart_type'] = action.chart_type;
      object['id'] = action.id;
      object['parent_type'] = action.parent_type;
      if (new_state[action.parent_type]) {
        new_state[action.parent_type].push(object);
      } else {
        new_state[action.parent_type] = [object];
      }
      // new_state[action.parent_type][action.group].push(object);
      return new_state;
    case UPDATEFIELD:
      var field = action.field;
      //var object = {};
      //object[field] = action.data;
      var object = state[action.data_parent][action.index];
      object[field] = action.data;
      state[action.data_parent][action.index] = object;
      return state;
    // return {
    //   ...state[action.data_parent][action.group].slice(0, action.index),
    //   // Copy the object before mutating
    //   Object.assign({}, state[action.data_parent][action.group][action.index], object),
    //   ...state[action.data_parent][action.group].slice(action.index + 1)
    // };
    case SORT:
      state[action.data_parent] = (0, _reactSortableHoc.arrayMove)(state[action.data_parent], action.oldIndex, action.newIndex);
      // console.log(sort_state);
      return state;
    case COPY:
      var object = JSON.parse((0, _stringify2.default)(state[action.data_parent][action.index]));
      object['id'] = action.id;
      // TODO: This is done so that when in single block templates, the default addition
      // would be to group 1 to have consistent behaviour. Can be discussed and removed.
      // if (action.group === '0'){
      //   object['group'] = '1';
      // }
      // console.log(state[action.data_parent][action.group].concat(object));
      state[action.data_parent] = state[action.data_parent].concat(object);
      // var copy_state = state.concat(state[action.index]);
      // copy_state = arrayMove(copy_state, copy_state.length - 1, action.index + 1)
      // return copy_state;
      return state;
    case DELETE:
      var delete_state = state;
      delete_state[action.data_parent].splice(action.index, 1);
      return delete_state;
    case CLEAN:
      return {};
    default:
      return state;
  }
}

function updateBlock(data, index) {
  return {
    type: UPDATEBLOCK,
    id: index,
    company: data.company,
    designation: data.designation,
    location: data.location,
    short_title: data.short_title,
    title: data.title,
    date_from: data.date_from,
    date_to: data.date_to,
    description: data.description,
    chart_data: data.chart_data,
    chart_type: data.chart_type
  };
}

function updateField(data, index, field, data_parent) {
  return {
    type: UPDATEFIELD,
    index: index,
    data: data,
    field: field,
    data_parent: data_parent
  };
}

function addBlock(data) {
  return {
    type: ADDBLOCK,
    company: data.company,
    heading: data.heading,
    designation: data.designation,
    location: data.location,
    short_title: data.short_title,
    title: data.title,
    date_from: data.date_from,
    date_to: data.date_to,
    description: data.description,
    chart_data: data.chart_data,
    chart_type: data.chart_type,
    id: data.id,
    parent_type: data.type
  };
}

function sort(oldIndex, newIndex, data_parent) {
  return {
    type: SORT,
    oldIndex: oldIndex,
    newIndex: newIndex,
    data_parent: data_parent
  };
}

function copyBlock(index, new_id, data_parent) {
  return {
    type: COPY,
    index: index,
    id: new_id,
    data_parent: data_parent
  };
}

function deleteBlock(index, data_parent) {
  return {
    type: DELETE,
    index: index,
    data_parent: data_parent
  };
}

function clean() {
  return {
    type: CLEAN
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/infoBlock.js
// module id = 211
// module chunks = 0